import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { ApplicationUsageStatistics } from 'types/application_usage_statistics';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';
import { useCurrentApplication } from './useCurrentApplication';

export function useApplicationUsageStatistics({
  enabled,
  ...options
}: UseQueryOptions<ApplicationUsageStatistics, APIError> = {}) {
  const { client } = useAPI();
  const { data: application } = useCurrentApplication();

  return useAuthenticatedQuery(
    ['application-usage-statistics', application?.id],
    async () => {
      if (!application) {
        return Promise.reject(new Error('No application provided.'));
      }

      const { data } = await client.get<ApplicationUsageStatistics>(
        `/internal/apps/${application.id}/usage_statistics`
      );
      return data;
    },
    {
      enabled:
        enabled !== undefined
          ? enabled && Boolean(application)
          : Boolean(application),
      ...options,
    }
  );
}
